import { sizeNumeric } from '@izettle/otto';

const ZINDEX_SINGLE_SELECT_POP_OVER = 20;
const ZINDEX_SINGLE_SELECT_INPUT_FOCUSED = 30;
const ZINDEX_SINGLE_SELECT_POP_OVER_FULLSCREEN = 100;
const CALENDAR_PADDING_SIZE = sizeNumeric.xSmall;
const CALENDAR_ROW_HEIGHT = 44;

export { CALENDAR_PADDING_SIZE, CALENDAR_ROW_HEIGHT, ZINDEX_SINGLE_SELECT_INPUT_FOCUSED, ZINDEX_SINGLE_SELECT_POP_OVER, ZINDEX_SINGLE_SELECT_POP_OVER_FULLSCREEN };
//# sourceMappingURL=constants.js.map
